import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CreateIcon from "@material-ui/icons/Create";

import Size from "components/tools/Size";
import { useCanvasMetrics, useCanvasSettings } from "utils/canvas";
import Radius from "components/RadiusManager";
import t from "translations";
import { Variations } from "comp/productselector/Variations";

export const SizeManager = styled(Size)({
  width: "100%",
  margin: "10px 0",
});

const RadiusManager = styled(Radius)({
  width: "100%",
  margin: 0,
});

const AccordionTitle = styled.div({
  alignItems: "center",
  display: "flex",
  ">span": {
    backgroundColor: "rgb(236,243,214)",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    color: "#A2C536",
    alignItems: "center",
  },
});

const AccordionHeader = ({ num, name, value, onEditClicked, editable }) => {
  return (
    <AccordionSummary
      onClick={() => onEditClicked(num)}
      style={{ opacity: editable ? 1 : 0.5 }}
    >
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <AccordionTitle>
          <span>{num}</span>
          <Typography style={{ paddingLeft: 10 }}>
            <b>{name}:</b> {value}
          </Typography>
        </AccordionTitle>
        {editable && (
          <ListItemIcon style={{ minWidth: "unset" }}>
            <CreateIcon />
          </ListItemIcon>
        )}
      </Grid>
    </AccordionSummary>
  );
};

export const DeskpadOptions = ({
  productVariations,
  selectedProduct,
  activeProduct,
  selectProduct,
  products,
  variantLabel,
}) => {
  const [expanded, setExpanded] = useState(1);
  const { isDynamicSize, isDynamicRadius} = useCanvasSettings();

  useEffect(() => {
    setExpanded(1);
  }, [activeProduct]);

  const metrics = useCanvasMetrics();
  return (
    <>
      {!!productVariations?.length && (
        <Accordion expanded={expanded === 1}>
          <AccordionHeader
            editable={productVariations?.length || selectedProduct?.parentId}
            num={1}
            name={"Variation"}
            value={variantLabel}
            onEditClicked={(num) => setExpanded(num)}
          />
          <AccordionDetails style={{ padding: "0 16px 0" }}>
            <Variations
              selectedProduct={selectedProduct}
              products={products}
              onChange={(product) => {
                selectProduct(product);
              }}
            />
          </AccordionDetails>
        </Accordion>
      )}

      <Accordion
        expanded={
          isDynamicSize && expanded === (productVariations?.length ? 2 : 1)
        }
      >
        <AccordionHeader
          editable={isDynamicSize && activeProduct}
          num={productVariations?.length ? 2 : 1}
          name={t.size}
          value={`${metrics.width}x${metrics.height}cm`}
          onEditClicked={(num) => setExpanded(num)}
        />
        <AccordionDetails style={{ padding: "0 16px 0" }}>
          <SizeManager />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={
          isDynamicRadius && expanded === (productVariations?.length ? 3 : 2)
        }
      >
        <AccordionHeader
          editable={isDynamicRadius && activeProduct}
          num={productVariations?.length ? 3 : 2}
          name={t.radius}
          value={`${metrics.radius}cm`}
          onEditClicked={(num) => setExpanded(num)}
        />
        <AccordionDetails style={{ padding: "0 16px 0" }}>
          <RadiusManager />
        </AccordionDetails>
      </Accordion>
    </>
  );
};
